var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.134 14.8813H1.2315V5.53435H4.134V14.8813ZM2.681 4.25935C1.753 4.25935 1 3.49035 1 2.56235C1 2.11652 1.1771 1.68895 1.49235 1.3737C1.8076 1.05845 2.23517 0.881348 2.681 0.881348C3.12683 0.881348 3.5544 1.05845 3.86965 1.3737C4.1849 1.68895 4.362 2.11652 4.362 2.56235C4.362 3.49035 3.609 4.25935 2.681 4.25935ZM14.997 14.8813H12.101V10.3313C12.101 9.24685 12.079 7.85635 10.592 7.85635C9.083 7.85635 8.8515 9.03435 8.8515 10.2533V14.8813H5.952V5.53435H8.7355V6.80935H8.776C9.1635 6.07485 10.11 5.29985 11.522 5.29985C14.4595 5.29985 14.9995 7.23435 14.9995 9.74685V14.8813H14.997Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.881348)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.06bd643f90bb02e38e930ee5456bb9d7.svg";
export { ForwardRef as ReactComponent };